import { JSX } from "preact/jsx-runtime";
import { useTranslation } from "react-i18next";

type Locale = "en" | "ru";

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const locale = (i18n.language as Locale) || ("en" as Locale);
  const availableLocales: Locale[] = ["en", "ru"];

  const localeNames: Record<Locale, string> = {
    en: "English",
    ru: "Русский",
  };

  return (
    <select
      value={locale}
      onChange={(e: JSX.TargetedEvent<HTMLSelectElement>) =>
        i18n.changeLanguage(e.currentTarget.value as Locale)
      }
      className="language-switcher"
    >
      {availableLocales.map((loc) => (
        <option key={loc} value={loc}>
          {localeNames[loc]}
        </option>
      ))}
    </select>
  );
}
